import { api } from '../../plugins/axios';
export default class OrdersService {
	static getPickupLocations(params = {}) {
		return api.get('/shipping/oto/pickup-locations', { params }).then((res) => {
			return {
				data: res.data.result['pickup-locations'].data,
				totalRecords: res.data.result['pickup-locations'].total,
			};
		});
	}
	static getDeliveryCompanies(data = {}) {
		return api.post('/main-order/shipment/check-delivery-fee', data).then((res) => {
			return res.data.result.delivery_companies;
		});
	}
}
